import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig from '../useGetFetchConfig';
import { BoundingBox } from '@/types';

interface ChunkMatch {
  id: string;
  content: string;
  boundingBoxes: BoundingBox[] | null;
}

export const useGetDocChunkMatchesV2 = (matterId: string | null | undefined, docId: string, searchQuery: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<{ chunks: ChunkMatch[] }>(
    [QueryEntity.DocumentChunkMatches, { matterId, docId, searchQuery }],
    () => {
      const params = new URLSearchParams({ searchQuery });
      return fetch(
        `${APIBaseChronos}/api/matters/${matterId}/docs/${docId}/chunk-matches?${params}`,
        fetchConfigGET,
      ).then((res) => res.json());
    },
    {
      enabled: !!matterId && !!docId && !!searchQuery && searchQuery.trim() !== '',
      refetchOnWindowFocus: false,
    },
  );
};
